import { useDisclosure } from '@mantine/hooks';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import ExportDonationsModal from '../ExportDonationsModal';
import type { ITransactionFilters } from '../TransactionTable/TransactionFilters.types';

interface IProps {
  /**
   * Active filters from the TransactionTable filter drawer. The export will
   * apply these to the generated CSV so the user gets the same data they're
   * looking at in the table.
   */
  filters: ITransactionFilters;
}

function ExportDonationsButton({ filters }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure(false);

  return (
    <>
      <Button
        aria-label={t('Export donation activity')}
        onClick={openModal}
        prefix={getIconForAction('export')}
        type={'secondary'}
      >
        {t('Export')}
      </Button>
      {isModalOpen && (
        <ExportDonationsModal filters={filters} onClose={closeModal} opened={isModalOpen} />
      )}
    </>
  );
}

export default ExportDonationsButton;
